import TransactionsCard from "./TransactionsCard";

export default TransactionsCard;
